import hostToTemplates from "../constants/host_templates";
export const getUrlSearchParams = () => {
    const params = new URL(window.location.href).searchParams;
    const hostname = window.location.hostname;

    console.log("params", params)
    console.log("hostname", hostname)

    if (hostToTemplates[hostname]) {
        const htmpl = hostToTemplates[hostname];
        return { template: htmpl.templateId, theme: htmpl.theme }
    } else {
        const template = params.get('template') || null;
        const theme = params.get('theme') || null;
        if (!template && !theme) return {};
        if (template && !theme) return { template };
        if (!template && theme) return { theme };
        return { template, theme }
    }
}
